<template>
    <div class="row">
      <div class="col-md-9">
        <h3>{{ $t("team.title") }}</h3>
        <h4 class="mb-20">{{ $t("team.subtitle") }}</h4>
          <input v-model="primaryEmail" class="form-control mb-20" id="campaign-team-address" :placeholder="$t('team.primaryEmail')">
          <button @click="sendInvitation(primaryEmail, true)" :value="primaryEmail" type="button" :class="'btn btn-default btn-lg button-wide-' + crowdOrRais">{{ $t('save') }}</button>
          <alert :success="alert.success" :error="alert.error"></alert>
      </div><!-- .col-md-9 -->
      <div class="col-md-3">
        <div class="all-categories mt-0 mb-20">
          <strong>{{ $t("team.campaignTeam") }}</strong>
        </div>
        <p class="mb-20">{{ $t("team.campaignTeamDescription") }}</p>
        <input v-model="memberEmail" type="text" class="form-control mb-20" id="campaign-new-team-email" :placeholder="$t('team.campaignTeamEmail')">
        <button @click="sendInvitation(memberEmail, false)" type="button" :class="'btn btn-default btn-lg mb-20 button-wide-' + crowdOrRais">{{ $t("team.campaignSendInvitationButton") }}</button>
      </div><!-- .col-md-3 -->
      <div class="col-md-12">
        <div class="all-categories mt-0 mb-20">
          <strong>{{ $t("team.campaignOwner") }}</strong>
        </div>
        <div class="owner">
          <div class="avatar" style="height:200px">
            <img v-if="project.user.photo.thumb.url" :src="$server_url + project.user.photo.thumb.url" style="width:200px">
          </div>
          <h4>{{ project.user.full_name }}</h4>
        </div>
      </div>
      <div class="col-md-12">
        <h3>{{ $t('team.campaignTeam') }}</h3>
        <div v-for="collaborator in collaborators">
          <router-link :to="{ name: 'show_profile', params: { id: collaborator.user.id } }">{{ collaborator.user.full_name }}</router-link>
          <span v-if="collaborator.confirmed"></span>
          <span v-if="collaborator.confirmation_sent_at"> - waiting for confirmation</span>
        </div>
      </div>
    </div><!-- .row -->
</template>

<script>
// API
import teamApi from '@/api/v1/team';
// Components
import Alert from '@/components/Alert';
// Mixins
import alert from '@/mixins/alert';

export default {
  mixins: [alert],
  props: ['project'],
  components: { Alert },
  data() {
    return {
      primaryEmail: '',
      memberEmail: '',
      collaborators: [],
    };
  },
  methods: {
    sendInvitation(email, isPrimary) {
      this.clearAlerts();
      teamApi.sendInvitation(this.project.id, email, isPrimary).then(() => {
        this.alert.success = this.$t('team.invitationSentAlert');
      }).catch((response) => {
        const data = response.response.data;
        if (data.collaborator) this.alert.error = data.collaborator[0];
        if (data.user) this.alert.error = data.user[0];
        if (data.contact) this.alert.error = data.contact[0];
      });
    },
  },
  computed: {
    crowdOrRais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
  },
  created() {
    teamApi.getProjectCollaborators(this.$route.params.id, (response) => {
      this.collaborators = response;
    });
  },
};
</script>



// WEBPACK FOOTER //
// Team.vue?1ca4f8eb